// Scriptstijlen als eigen pagina, buiten Admin.
//
// Joris, 10 sep 2026: "kan de achterkant ook toegankelijk zijn voor regisseurs
// en comm adviseurs". Die staan niet als aparte functie in Personen, en dit is
// geen gevoelige configuratie — dus geen rolslot: iedereen met een login kan de
// stijl van een filmtype bijschaven. Wie de stijl van een explainer kent is de
// regisseur, niet de beheerder. Het beheerscherm zelf is hetzelfde component
// dat ook onder Admin → Scriptstijlen hangt.
import { Box } from '@mui/material';
import PageHeader from '../../ui-components/PageHeader';
import Scriptstijlen from '../AdminSettings/sections/Scriptstijlen';

export default function ScriptstijlenPage() {
  return (
    <Box sx={{ width: '100%', maxWidth: 1100, mx: 'auto', px: { xs: 2, sm: 3, md: 5 }, pt: { xs: 3, md: 5 }, pb: 6 }}>
      <PageHeader
        icon="edit_note"
        title="Scriptstijlen"
        subtitle="Per filmtype de schrijfstijl waar de scriptgenerator mee werkt"
        accent={{ color: '#635983', bg: '#dbcdff' }}
      />
      <Scriptstijlen />
    </Box>
  );
}
